import { MdOutlineInsertDriveFile } from 'react-icons/md';

const badgeClass = 'inline-flex items-center gap-[2px] shrink-0 bg-base-55 rounded py-[2px] pl-[2px] pr-1';
const labelClass = 'text-[10px] font-medium leading-none text-base-10 truncate max-w-[120px]';

type FileBadgeProps = {
  title: string;
};

export const FileBadge = ({ title }: FileBadgeProps) => (
  <span className={badgeClass}>
    <MdOutlineInsertDriveFile size={12} className="shrink-0 text-base-10" />
    <span className={labelClass}>{title}</span>
  </span>
);
